import React from "react";

import { Box } from "@mui/material";

import ModernModal from "../ModernModal";
import QuoteModal, { QuoteObject } from "./parts/QuoteModal";
import { Chapter, Quote } from "../../Episode/services/episode.service";
import { toHHMMSS } from "../../../utils/formatTIme";
import TitleModal from "./parts/TitleModal";
import { Category } from "../types";
import ChapterModal from "./parts/ChapterModal";
import ContentModal from "./parts/ContentModal";

export enum ModalType {
  QUOTES = "quotes",
  TITLES = "titles",
  CHAPTERS = "chapters",
  BLOGPOST = "blog_posts",
  NEWSLETTER = "newsletter",
  KEYWORDS = "keywords",
  TWEETS = "tweets",
}

interface Props {
  open: boolean;
  setOpen: (value: boolean) => void;
  modalTitle: string;
  modalType: ModalType;
  objectValue: any;
  values: any;
  refetch: () => void;
  category: Category;
}

const getModalTitle = (
  modalType: ModalType,
  modalTitle: string,
  objectValue: any,
) => {
  switch (modalType) {
    case ModalType.QUOTES:
      return `${modalTitle} - ${toHHMMSS(objectValue.timestamp as keyof QuoteObject)}`;
    case ModalType.TITLES:
      return modalTitle;
    case ModalType.TWEETS:
      return "Edit Tweet";
    case ModalType.KEYWORDS:
      return "Edit Keyword";
    case ModalType.CHAPTERS:
      return "Edit Chapter";
    case ModalType.BLOGPOST:
      return "Edit Blog Post";
    case ModalType.NEWSLETTER:
      return "Edit Newsletter";
    default:
      return modalTitle;
  }
};

function InsightsModalManager({
  open,
  setOpen,
  modalTitle,
  modalType,
  objectValue,
  values,
  refetch,
  category,
}: Props) {
  const handleClose = () => setOpen(false);

  const title = getModalTitle(modalType, modalTitle, objectValue);

  const renderModalContent = () => {
    switch (modalType) {
      case ModalType.QUOTES:
        return (
          <QuoteModal
            category={Category.QUOTES}
            quoteObject={objectValue as QuoteObject}
            quotes={values as Quote[]}
            handleCloseModal={handleClose}
            refetch={refetch}
          />
        );
      case ModalType.TITLES:
        return (
          <TitleModal
            title={objectValue.title as keyof { title: string }}
            titles={values as string[]}
            handleCloseModal={handleClose}
            refetch={refetch}
            category={category}
          />
        );
      case ModalType.CHAPTERS:
        return (
          <ChapterModal
            chapter={objectValue.title as keyof { title: string }}
            chapters={values as Chapter[]}
            handleCloseModal={handleClose}
            refetch={refetch}
            category={category}
          />
        );
      case ModalType.BLOGPOST:
      case ModalType.NEWSLETTER:
        return (
          <ContentModal
            title={
              modalType === ModalType.BLOGPOST ? "Blog Post" : "Newsletter"
            }
            content={objectValue.title as keyof { title: string }}
            handleCloseModal={handleClose}
            refetch={refetch}
            category={category}
          />
        );
      default:
        return <Box>Content not available</Box>;
    }
  };

  return (
    <ModernModal open={open} onClose={handleClose} title={title} maxWidth="md">
      {renderModalContent()}
    </ModernModal>
  );
}

export default InsightsModalManager;
